import DOMPurify from "dompurify";

interface SafeHtmlProps {
  html: string;
  fontSize?: string;
  color?: string;
}

export const SafeHtml = ({ html, fontSize = "14px", color = "inherit" }: SafeHtmlProps) => (
  <div
    style={{ fontSize, color }}
    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
  />
);